<template>
    <div>
        <limitless-page-header
            title="Leverantörer"
            :sub-title="(supplier && supplier.ProdSupplierID > 0 ? supplier.Name : (not_found ? '???' : 'Ny Leverantör'))"
            :title-id="(supplier && supplier.ProdSupplierID > 0 ? supplier.ProdSupplierID : '')"
        ></limitless-page-header>

        <div class="content" style="padding-bottom: 6rem;">
            <div v-if="!supplier && not_found">
                <i class="text-danger font-italic">Leverantören hittades inte...</i>
            </div>
            <div v-else-if="!supplier && error">
                <i class="text-danger font-italic">Något gick fel, kunde inte hämta data...</i>
            </div>
            <b-skeleton v-else-if="!supplier" height="69px" style="margin-bottom: 1.25rem;"></b-skeleton>

            <limitless-card-tabs-view :links="routes" v-show="supplier">
                <router-view @supplierUpdated="getSupplier"></router-view>
                <activity-notification v-if="supplier && supplier.ProdSupplierID > 0" :channel="'supplier-' + supplier.ProdSupplierID"></activity-notification>
            </limitless-card-tabs-view>
        </div>
    </div>
</template>

<script>
import LimitlessCardTabsView from '@components/Limitless/CardTabsView';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import ActivityNotification from '@components/User/ActivityNotification';
import apiClient from '@services/ApiClient';

export default {
    name: 'SupplierEditor',
    components: {
        LimitlessCardTabsView,
        LimitlessPageHeader,
        ActivityNotification,
    },
    data: () => ({
        id: null,
        supplier: null,
        error: false,
        not_found: false,
    }),
    async created() {
        if (this.$route.params.id) {
            this.id = this.$route.params.id;
        }
    },
    watch: {
        '$route.params.id': function watchRouteParamsId(id) {
            this.id = id;
        },
        id: function watchId() {
            this.supplier = null;
            this.getSupplier();
        },
    },
    methods: {
        getSupplier() {
            apiClient.get('/vue/suppliers/' + this.id).then((response) => {
                this.supplier = response.data;
                this.not_found = false;
                this.error = false;
            }).catch((error) => {
                this.supplier = null;
                if (error.response) {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    } else {
                        this.error = true;
                    }
                }
            });
        },
    },
    computed: {
        routes() {
            const { id } = this.$route.params;
            return [
                { name: 'suppliers.edit', params: { id }, text: 'Leverantör' },
                { name: 'suppliers.products', params: { id }, text: 'Produkter' },
                { name: 'suppliers.purchases', params: { id }, text: 'Beställningar' },
            ];
        },
    },
};
</script>
